/*jshint esversion: 6 */
document.addEventListener('DOMContentLoaded', () => {
	const body = document.body;

	// Add event listeners to expandable nav items
	const navExpandItems = [...document.querySelectorAll('.nav-expand')];

	navExpandItems.forEach(item => {
		const expandLink = item.querySelector('.nav-expand-link');
		const backLink = item.querySelector('.nav-back-link');

		expandLink.addEventListener('click', () => item.classList.add('active'));
		backLink.addEventListener('click', () => item.classList.remove('active'));
	});

	// Setup and append overlay
	const overlay = document.createElement('div');
	overlay.id = 'body-overlay';
	body.appendChild(overlay);

	// Select elements for search and menu toggling
	const toggleSearchDialog = document.getElementById('search-toggle');
	const toggleResponsiveMenu = document.getElementById('nav-mobile-toggle');
	const bodyOverlay = document.getElementById('body-overlay');

	// Toggle responsive menu
	toggleResponsiveMenu.addEventListener('click', () => {
		body.classList.toggle('nav-is-toggled');
		body.classList.remove('search-is-toggled');
	});

	// Toggle search dialog
	toggleSearchDialog.addEventListener('click', () => {
		body.classList.toggle('search-is-toggled');
		body.classList.remove('nav-is-toggled');
	});

	function closeMenuAndSearch() {
		body.classList.remove('nav-is-toggled', 'search-is-toggled');
	}
	  
	// Hide menu, search, and overlay when the overlay is clicked
	bodyOverlay.addEventListener('click', closeMenuAndSearch);
	
	// Close menu and search on window resize
	window.addEventListener('resize', closeMenuAndSearch);
	
	// Function to calculate left offset for submenus
	const getOffsetLeft = (element) => {
		let offsetLeft = 0;
		while (element.parentElement) {
			element = element.parentElement;
			if (element.classList.contains("hasChildren") && element.offsetLeft !== 0) {
				offsetLeft = element.offsetLeft;
				break;
			}
		}
		return offsetLeft;
	};

	// Function to check submenu position and handle underflow
	const checkSubmenuPosition = (elements) => {
		const hasChildren = document.querySelectorAll(elements);

		hasChildren.forEach(element => {
			element.addEventListener('mouseenter', () => {
				let submenuLevel = parseInt(element.dataset.level, 10);
				const submenu = element.querySelector('ul');
				const offsetLeftValue = getOffsetLeft(element);
				let offsetParent = element.offsetLeft || offsetLeftValue;
				if (!element.offsetLeft) submenuLevel += 1;

				const offsetLeft = submenu.offsetLeft + offsetParent;
				const submenuWidth = submenu.offsetWidth;
				const docWidth = body.clientWidth;

				if (offsetLeft + (submenuWidth * submenuLevel) >= docWidth) {
					submenu.parentElement.classList.add('underfold-end');
				} else {
					submenu.parentElement.classList.remove('underfold-end');
				}
			});

			element.addEventListener('mouseleave', () => {
				const submenu = element.querySelector('ul');
				submenu.parentElement.classList.remove('underfold-end');
			});
		});
	};

	// Call the function initially and on window resize
	checkSubmenuPosition('#nav-desktop-secondary li.hasChildren');
	window.addEventListener('resize', () => checkSubmenuPosition('#nav-desktop-secondary li.hasChildren'));
});